(function () {
    const INIT_FLAG = "mbCopyDescriptionInit"; // dataset flag name

    const SELECTORS = {
        BUTTON: "[data-copy-btn]",
        DESCRIPTION: "[data-description-content]",
        TITLE: [
            "[data-product-title]",
            ".product__title",
            ".product-title",
            "h1.product-single__title",
            "main h1",
            "h1",
        ],
    }

    const emoticons = {
        diamond_blue: "🔹",
        diamond_orange: "🔸"
    }

    const subitoHeaderBadges = {
        blue: ["Prestazioni", "Compatibilita", "Compatibilità", "Per chi e indicato", "Per chi è indicato", "Cosa pulisce"],
        orange: ["Condizioni", "Consulenza"],
    }

    function fallbackCopyText(text) {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
    }

    async function copyText(text) {
        if (!text) return;

        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return;
        }

        fallbackCopyText(text);
    }

    function getBaseFormattedText(descriptionEl) {
        const clone = descriptionEl.cloneNode(true);
        const blocks = [];

        clone.querySelectorAll("span").forEach((span) => {
            const text = (span.textContent || "").trim();
            if (/^TAGS:/i.test(text)) {
                span.remove();
            }
        });

        clone.querySelectorAll("li").forEach((li) => {
            const liText = li.textContent.trim();
            if (!liText) return;

            li.textContent = liText.startsWith("-") ? liText : `- ${liText}`;
        });

        clone.querySelectorAll("h1, h2, h3, h4, h5, h6, p, ul, ol").forEach((el) => {
            const tagName = el.tagName;
            if (/^H[1-6]$/.test(tagName) || tagName === "P") {
                const text = el.textContent.trim();
                if (text) {
                    blocks.push(text);
                }
                return;
            }

            const listRows = Array.from(el.querySelectorAll("li"))
                .map((li) => li.textContent.trim())
                .filter(Boolean);

            if (listRows.length) {
                blocks.push(listRows.join("\n"));
            }
        });

        if (!blocks.length) {
            return (clone.innerText || clone.textContent || "")
                .split("\n")
                .map((line) => line.trim())
                .filter((line, index, arr) => line || arr[index - 1])
                .join("\n")
                .trim();
        }

        return blocks.join("\n\n").trim();
    }

    function removeEmoticons(text) {
        const withoutEmoji = text
            .replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, "")
            .replace(/[\uFE0E\uFE0F\u200D]/g, "");

        return withoutEmoji
            .split("\n\n")
            .map((block) =>
                block
                    .replace(/\s{2,}/g, " ")
                    .replace(/\n +/g, "\n")
                    .trim()
            )
            .join("\n\n")
            .trim();
    }

    function formatForSubito(descriptionEl) {
        const clone = descriptionEl.cloneNode(true);

        clone.querySelectorAll("h3").forEach((h3) => {
            const text = (h3.textContent || "").trim();
            if (!text) return;

            const lowerText = text.toLowerCase();
            const hasBadge = text.startsWith(emoticons.diamond_blue) || text.startsWith(emoticons.diamond_orange);
            if (hasBadge) return;

            const isBlue = subitoHeaderBadges.blue.some((keyword) => lowerText.startsWith(keyword.toLowerCase()));
            const isOrange = subitoHeaderBadges.orange.some((keyword) => lowerText.startsWith(keyword.toLowerCase()));

            if (isBlue) {
                h3.textContent = `${emoticons.diamond_blue} ${text}`;
                return;
            }

            if (isOrange) {
                h3.textContent = `${emoticons.diamond_orange} ${text}`;
            }
        });

        return getBaseFormattedText(clone);
    }

    function formatForOlx(descriptionEl) {
        const clone = descriptionEl.cloneNode(true);

        clone.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach((heading) => {
            const text = (heading.textContent || "").trim();
            if (!text) return;

            heading.textContent = text.toUpperCase();
        });

        return removeEmoticons(getBaseFormattedText(clone));
    }

    function getFormattedText(type, descriptionEl) {
        const formatters = {
            olx: formatForOlx,
            subito: formatForSubito,
        };

        const formatter = formatters[type] || formatForSubito;
        return formatter(descriptionEl);
    }

    function getProductTitle(rootEl) {
        for (const selector of SELECTORS.TITLE) {
            const titleEl = rootEl.querySelector(selector) || document.querySelector(selector);
            const text = (titleEl?.textContent || "").trim();
            if (text) return text;
        }

        const ogTitle = document.querySelector('meta[property="og:title"]')?.getAttribute("content")?.trim();
        if (ogTitle) return ogTitle;

        return "";
    }

    function initCopyActions(rootEl) {
        const descriptionEl = document.querySelector(SELECTORS.DESCRIPTION);
        const copyActions = rootEl.querySelectorAll(SELECTORS.BUTTON);

        copyActions.forEach((btn) => {
            btn.addEventListener("click", async () => {
                const type = btn.dataset.copyBtn;
                // console.log("Copy button clicked:", type);
                const shouldCopyTitle = type === "title";

                if (!descriptionEl && !shouldCopyTitle) {
                    console.warn("Description element not found");
                    return;
                }

                const text = shouldCopyTitle
                    ? getProductTitle(rootEl)
                    : getFormattedText(type, descriptionEl);

                if (!text) {
                    console.warn("Nothing to copy");
                    return;
                }

                // console.log(text);

                try {
                    await copyText(text);
                } catch (error) {
                    console.error("Copy failed", error);
                }
            })
        });
    }

    function initAll(root) {
        root.querySelectorAll("[data-copy-actions]").forEach(initCopyActions);
    }

    document.addEventListener("DOMContentLoaded", () => initAll(document));
    document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();
